import {css} from 'lit';
export const styles = css`:host {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 250px;
  min-width: 105px;
  color: var(--dark-text);
  text-align: center;
}

.tags {
  position: absolute;
  top: -6px;
  left: 50%;
  display: flex;
  width: 70%;
  justify-content: center;
  transform: translateX(-50%);
  z-index: 1;
}

.tag.color-10 {
  background-color: var(--tag-color-10);
}

.tag.color-20 {
  background-color: var(--tag-color-20);
}

.tag.color-30 {
  background-color: var(--tag-color-30);
}

.tag.color-40 {
  background-color: var(--tag-color-40);
}

.tag.color-50 {
  background-color: var(--tag-color-50);
}

.tag.color-60 {
  background-color: var(--tag-color-60);
}

.tag.color-70 {
  background-color: var(--tag-color-70);
}

.tag.color-80 {
  background-color: var(--tag-color-80);
}

.tag.color-90 {
  background-color: var(--tag-color-90);
}

.tag.color-100 {
  background-color: var(--tag-color-100);
}

.tag.color-110 {
  background-color: var(--tag-color-110);
}

.tag.color-120 {
  background-color: var(--tag-color-120);
}

.tag.color-130 {
  background-color: var(--tag-color-130);
}

.tag.color-140 {
  background-color: var(--tag-color-140);
}

.tag.color-150 {
  background-color: var(--tag-color-150);
}

.tag.color-160 {
  background-color: var(--tag-color-160);
}

.tag.color-170 {
  background-color: var(--tag-color-170);
}

.tag.color-180 {
  background-color: var(--tag-color-180);
}

.tag.color-190 {
  background-color: var(--tag-color-190);
}

.tag.color-200 {
  background-color: var(--tag-color-200);
}

.tag.color-210 {
  background-color: var(--tag-color-210);
}

.tag.color-220 {
  background-color: var(--tag-color-220);
}

.tag.color-230 {
  background-color: var(--tag-color-230);
}

.tag.color-240 {
  background-color: var(--tag-color-240);
}

.tag.color-250 {
  background-color: var(--tag-color-250);
}

.tag-v3 {
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
  margin-top: -6px;
  border: 2px solid #fff;
  font-size: 11px;
  padding: 4px 8px;
  color: #fff;
  border-radius: 10px;
}

.tag-v4 {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-left: 1px;
  margin-right: 1px;
  border: 2px solid #fff;
}

.image {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  margin-bottom: 8px;
  padding-bottom: 80%;
  background-color: #fff;
  border: 2px solid #fff;
  border-radius: 4px;
  overflow: hidden;
  transition: border-color ease 0.2s, background-color ease 0.2s;
}

.image img {
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 100%;
  max-height: 100%;
  padding: 8px 2px 2px;
  transform: translate(-50%, -50%);
}

.type {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.type ef-icon {
  font-size: 60px;
}

.type span {
  position: absolute;
  right: -16px;
  bottom: -4px;
  display: inline-block;
  padding: 2px 4px;
  border-radius: 4px;
  background-color: var(--file-type-file);
  font-size: 11px;
  color: #fff;
  text-transform: uppercase;
}

@media (min-width: 400px) {
  .type span {
    left: 53%;
    right: auto;
  }
}

.type.type-image span {
  background-color: var(--file-type-image);
}

.type.type-video span {
  background-color: var(--file-type-video);
}

.type.type-audio span {
  background-color: var(--file-type-audio);
}

.type.type-pdf span {
  background-color: var(--file-type-pdf);
}

.type.type-doc span {
  background-color: var(--file-type-doc);
}

.type.type-sheet span {
  background-color: var(--file-type-sheet);
}

.type.type-slide span {
  background-color: var(--file-type-slide);
}

.type.type-archive span {
  background-color: var(--file-type-archive);
}

.info {
  width: 100%;
  overflow: hidden;
}

.title {
  display: flex;
  justify-content: center;
  font-size: 12px;
  white-space: pre;
}

.title span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
}

.size {
  color: var(--dark-text-secondary);
  font-size: 11px;
}

:host(.active) .image {
  border-color: var(--primary-500);
}

@media (hover: hover) {
  :host(:hover) .image {
    border-color: var(--primary-500);
  }
}

:host(:active) .image {
  background-color: var(--gray-200);
}
`;
export default styles;
